// extracted by mini-css-extract-plugin
module.exports = {"svg":"styles-module--svg--3ZgWs","black":"styles-module--black--3qN1d","white":"styles-module--white---hVXO"};